<template>
    <div
        class="input-root d-flex align-items-center"
        :class="{
            'success-type': color === 'success',
            'error-type': color === 'error',
            'error-type-light': color === 'error-light',
            'thin-outline': thin === true,
            outline: outline === true,
        }"
    >
        <input
            ref="input"
            v-bind="$attrs"
            class="base-input"
            :class="[
                {
                    'success-bg': color === 'success',
                    'error-bg': color === 'error',
                    'error-type-light': color === 'error-light',
                    'pa-2': padding === true,
                },
                inputClass,
            ]"
            :value="value"
            @input="handleChange"
            v-on="listeners"
        />
        <div v-if="icon" class="d-flex align-items-center px-2">
            <BaseIcon :name="icon" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseInput',
    props: {
        value: { type: String, default: '' },
        icon: { type: String, default: '' },
        color: { type: String, default: '' },
        padding: Boolean, // For adding more padding
        thin: Boolean, // For setting a small outline width
        outline: { type: Boolean, default: true },
        inputClass: { type: String, default: '' },
    },
    computed: {
        listeners() {
            return {
                ...this.$listeners,
                input: this.handleChange,
            };
        },
    },
    methods: {
        handleChange(event) {
            this.$emit('input', event.target.value);
        },
        focus() {
            this.$refs.input.focus();
        },
    },
};
</script>

<style scoped>
.input-root {
    height: auto;
    overflow: hidden;
}
.base-input {
    border: none;
    height: 100%;
    width: 100%;
    padding: 8px;
    border-radius: 0.25rem;
}
.outline {
    border-width: 1px;
    border-style: solid;
    border-radius: 0.25rem;
    border-color: rgba(0, 0, 0, 0.4);
}
.base-input:focus {
    outline-color: var(--primary); /* rgba(0, 0, 0, 0.5); */
}

/* Colors */
.success-type {
    border-color: var(--success);
    color: var(--success);
}
.success-bg {
    background-color: var(--success-transparent);
}
.error-type {
    border-color: var(--error);
    color: var(--error);
}
.error-type-light {
    background-color: var(--success-transparent);
    border-color: var(--error);
}
.error-bg {
    background-color: var(--error-transparent);
}

/* Miscellaneous */
.thin-outline {
    border-width: 1px !important;
}
</style>
